import axios from 'axios';

// VITE_API_BASE_URL deve apontar para a raiz do backend Laravel (ex: https://api.dominio.com).
// Normaliza para garantir que o sufixo /api sempre esteja presente, mesmo que a variavel de
// ambiente de build tenha sido configurada sem ele (todas as rotas da API Laravel usam prefixo /api).
const rawApiBaseUrl = (import.meta.env.VITE_API_BASE_URL || '/api').replace(/\/+$/, '') || '/api';
const apiBaseUrl = /\/api$/.test(rawApiBaseUrl) ? rawApiBaseUrl : `${rawApiBaseUrl}/api`;

const api = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Interceptor para adicionar token em todas as requisições
api.interceptors.request.use(
  (config) => {
    const url = config.url || '';
    const isLoginRequest = url.includes('/auth/login');
    const token = localStorage.getItem('token');
    if (token && !isLoginRequest) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor para tratar erros de autenticação
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);

export default api;
